var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import { wordCount } from "../utils/string_tools";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import { SpaciousPaper, WhiteSpacePreservingTypography } from "./styleComponents";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import { ItemContent, StyledTextField } from "./styleComponents";
import MarkdownText from "./MarkdownText";
import ThemeProviderContext from "../contexes/themeProviderContext";
var AnswerPaper = styled(SpaciousPaper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var AnswerField = styled(StyledTextField)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var SubmitHelperTypography = styled(Typography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 0.5rem;\n  && {\n    height: 1rem;\n    padding-top: 1rem;\n    color: ", ";\n    font-weight: ", "\n    font-size: ", ";\n  }\n"], ["\n  margin-bottom: 0.5rem;\n  && {\n    height: 1rem;\n    padding-top: 1rem;\n    color: ", ";\n    font-weight: ", "\n    font-size: ", ";\n  }\n"])), function (_a) {
  var attemptWasRecentlyMade = _a.attemptWasRecentlyMade;
  return attemptWasRecentlyMade ? "#AD0000" : "#595959";
}, function (_a) {
  var attemptWasRecentlyMade = _a.attemptWasRecentlyMade;
  return attemptWasRecentlyMade ? "bold" : "inherit";
}, function (_a) {
  var attemptWasRecentlyMade = _a.attemptWasRecentlyMade;
  return attemptWasRecentlyMade ? "1.2rem" : "0.85rem";
});
var Essay = function Essay(_a) {
  var item = _a.item;
  var themeProvider = React.useContext(ThemeProviderContext);
  var dispatch = useDispatch();
  var handleTextDataChange = function handleTextDataChange(e) {
    return dispatch(quizAnswerActions.changeTextData(item.id, e.currentTarget.value));
  };
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var recentlyAttemptedDisabledSubmit = useTypedSelector(function (state) {
    return state.quizAnswer.attemptedDisabledSubmit;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  if (!languageInfo) {
    return React.createElement("div", null);
  }
  var essayLabels = languageInfo.essay;
  var itemBody = item.body;
  var itemTitle = item.title;
  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  var possibleToSubmit = true;
  if (userQuizState) {
    if (userQuizState.status === "locked") {
      possibleToSubmit = false;
    }
  }
  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }
  var answerText = itemAnswer ? itemAnswer.textData || "" : "";
  var numOfWords = wordCount(answerText);
  var answerWithinLimits = numOfWords >= (item.minWords || 0) && numOfWords <= (item.maxWords || 666666);
  var answerPortion = !possibleToSubmit ? React.createElement(React.Fragment, null, React.createElement(Typography, {
    component: "p",
    variant: "subtitle1"
  }, essayLabels.userAnswerLabel + ": "), React.createElement(AnswerPaper, {
    providedStyles: themeProvider.answerPaperStyles
  }, React.createElement(WhiteSpacePreservingTypography, {
    variant: "body1"
  }, answerText))) : React.createElement(React.Fragment, null, React.createElement(Typography, null, essayLabels.wordLimitsGuidance(item.minWords, item.maxWords)), React.createElement(AnswerField, {
    rowNumber: item.order,
    variant: "outlined",
    label: essayLabels.textFieldLabel,
    value: answerText,
    onChange: handleTextDataChange,
    fullWidth: true,
    multiline: true,
    rows: 10,
    margin: "normal",
    providedStyles: themeProvider.answerFieldStyles,
    id: "essay-text-field"
  }), React.createElement("div", null, React.createElement(Typography, null, essayLabels.currentNumberOfWordsLabel, ": ", numOfWords), React.createElement(SubmitHelperTypography, {
    attemptWasRecentlyMade: recentlyAttemptedDisabledSubmit
  }, answerWithinLimits ? "" : essayLabels.conformToLimitsToSubmitLabel)));
  return React.createElement(ItemContent, {
    providedStyles: themeProvider.essayItemContentStyles
  }, itemTitle && React.createElement(MarkdownText, {
    Component: Typography,
    variant: "h6",
    variantMapping: {
      h6: "p"
    }
  }, itemTitle), itemBody && React.createElement(MarkdownText, {
    variant: "body1"
  }, itemBody), quizDisabled ? React.createElement(AnswerField, {
    rowNumber: item.order,
    variant: "outlined",
    fullWidth: true,
    multiline: true,
    rows: 5,
    margin: "normal",
    disabled: true,
    providedStyles: themeProvider.answerFieldStyles
  }) : answerPortion);
};
export default Essay;
var templateObject_1, templateObject_2, templateObject_3;